<template>
  <div class="box" v-if="datas">
    <div class="fvl head">
      <img class="readyTyre" src="../../../assets/images/readyTyre.svg" alt="" />
      {{ datas.status }}
    </div>
    <div class="orderNum pd">订单编号:{{ datas.order_no }}</div>
    <TyreCard :datas="datas.tyre" from="order" @link="toDetail(datas.tyre)" />
    <div class="pd">
      <template v-for="(item, index) in info" :key="index">
        <div v-if="item.type === 'img'">
          <div class="fvlr common">
            <div class="left">{{ item.key }}</div>
          </div>
          <div class="fvlrw">
            <img class="tyreImg" :src="item" v-for="(item, index) in item.value" :key="index" />
          </div>
        </div>

        <div v-else class="fvlr common">
          <div class="left">{{ item.key }}</div>
          <div class="right">{{ item.value }}</div>
        </div>
      </template>
    </div>
    <div class="fc"><van-icon name="question-o" />&nbsp;&nbsp;最终支付金额依据经销商店内实际销售价为准</div>
    <van-button class="btn pd" @click="back" type="primary">返回</van-button>
  </div>
</template>

<script>
/* 轮胎专享暂时不用 */
import { reactive, toRefs, onMounted } from 'vue'
import TyreCard from '@/components/tyre/TyreCard'
import { orderTyreDetail as datas } from '@/mock/tyreOrderDetai'
import { getOrdersDetail } from '@/api/tyre'
import { getInfo } from '@/util/tyreExclusiveOrder'
import { useRouter } from 'vue-router'
export default {
  components: {
    TyreCard
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      count: 0,
      datas,
      detail: [],
      info: []
    })
    onMounted(async () => {
      state.detail = [
        {
          label: '服务类型',
          value: ''
        }
      ]
      let param = {
        orderId: '121437'
      }
      let { order } = await getOrdersDetail(param)
      order.tyre.has_commodity = true
      order.tyre.msrp = order.amount
      state.datas = order
      state.info = getInfo(order)
    })
    const back = () => {
      router.go(-1)
    }
    return {
      ...toRefs(state),
      back
    }
  }
}
</script>

<style lang="scss" scoped>
.tyreImg {
  width: 80px;
  height: 80px;
  margin-bottom: 5px;
}
.btn {
  margin-top: 20px;
  width: calc(100% - 40px);
  margin-bottom: 60px;
}
.pd {
  padding: 0 20px;
  margin-bottom: 10px;
}
.box {
  background: #fff;
  color: #666666;
  box-sizing: border-box;
  overflow: auto;
  // background: red;
  :deep(.card) {
    margin: 8px 0 24px;
  }
}
.orderNum {
  text-align: left;
  font-size: 13px;
}
.head {
  padding: 30px 20px 0;
  font-size: 14px;
  color: #3088c5;
  margin-bottom: 33px;
  .readyTyre {
    margin-right: 8px;
  }
}
.common {
  box-sizing: border-box;
  padding: 0 0 12px;
  font-size: 14px;
  color: #333333;
  .left {
    color: #666666;
  }
}
</style>
